import React, { useState, Fragment, Component } from 'react';
import { Card, CardHeader, CardBody, CustomInput, Button, FormGroup, Label, Form, Input, InputGroup, Row, Col, DropdownMenu, DropdownItem } from 'reactstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import * as cardUtils from './js/index';
import { toast, Slide } from 'react-toastify';
import { MaskedTextBoxComponent } from '@syncfusion/ej2-react-inputs';
const Example = () =>
{
    const [startDate, setStartDate] = useState(new Date());
    return (
        <DatePicker id="card_expirationDate_input" selected={startDate} onChange={date => setStartDate(date)} showMonthYearPicker dateFormat="MM/yyyy" className="form-control" />
    );
};
export default class BuyWithCreditCard extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            exp_date: new Date(),
            cardType:"Visa"
        }
    }
    setStartDate = (date) =>
    {
        this.state({ exp_date: date });
    }
    showToast(msg, AlertType)
    {
        this.toastId = toast(msg, {
            transition: Slide,
            closeButton: true,
            autoClose: 5000,
            position: 'bottom-center',
            type: AlertType,
        });
    }
    onChangeFirstname = (e) =>
    {
        this.setState({ firstName: e.target.value });
    }
    onChangeLasttname = (e) =>
    {
        this.setState({ lastName: e.target.value });
    }
    onChangeCardNumber = (e) =>
    {
        var temp = e.target.value;
       
        this.setState({ cardNumber: temp, cardNumberShow: temp })
    }
    onCardNumberBlur = (e) =>
    {
        var temp = e.target.value;
        if (e.target.value.length > 12)
        {

            var res = e.target.value.slice(0, -4).replace(/./g, '*') + e.target.value.slice(-4)
            console.log("card number res= ", res);
            this.setState({ cardNumber: temp, cardNumberShow: res });
        }
        else
        {
            var res = e.target.value.replace(/./g, '*')
            this.setState({ cardNumber: temp, cardNumberShow: res });
        }

    }
    onCardNumberFocus = () =>
    {
        this.setState({ cardNumberShow: this.state.cardNumber })
    }
    onChangeCardVerficationNumber = (e) =>
    {
        this.setState({ verficationNumber: e.target.value });
    }
    onChangeCardAddress = (e) =>
    {
        this.setState({ cardAddress: e.target.value });
    }
    onChangeCardState = (e) =>
    {
        this.setState({ cardState: e.target.value });
    }
    onChangeCardCity = (e) =>
    {
        this.setState({ cardCity: e.target.value });
    }
    onChangeCardZIPCode = (e) =>
    {
        this.setState({ cardZIPCode: e.target.value });
    }
    onChangeCardTypeSelect = (e) =>
    {
        this.setState({ cardType: e.target.value })
    }
    onChangeEmail = (e) =>
    {
        
        this.props.onChangeEmail(e.target.value);
    }
    onChangePurchasedEmail = (e) => { }
    render()
    {
        return <Fragment>
           
            <Card>
                {this.props.Title !== "" && this.props.Title !== undefined ?
                    <CardHeader>{this.props.Title}</CardHeader> : null}
                <CardBody>
                    <Row>
                        <Col sm="6">
                            
                            <Fragment>
                                <FormGroup>
                                    <Label>Total Money : </Label><Label style={{ fontWeight: "bold" }}>&nbsp;{"$ " + this.props.Price}</Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Firstname">First name*</Label>
                                    <Input type="text" name="Firstname" id="Firstname"
                                        placeholder="First name" onChange={this.onChangeFirstname} />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="lastname">Last name *</Label>
                                    <Input type="text" name="lastname" id="lastname"
                                        placeholder="Last name" onChange={this.onChangeLasttname} />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="cardtype">Card Type</Label>
                                    <CustomInput id="ddlcardType" type="select" size="1" onChange={this.onChangeCardTypeSelect}>
                                        <option key="visa" value="Visa">Visa</option>
                                        <option key="Master" value="Master Card">Master Card</option>
                                        <option key="Amircan" value="American Express">Amircan Express</option>
                                        <option key="Discover" value="Discover">Discover</option>
                                    </CustomInput>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="cardnumber">Card Number</Label>
                                    {/* <MaskedTextBoxComponent mask="0000-0000-0000-0000" value={this.state.cardNumberShow} style={{ width: "100%" }} promptChar="_" onChange={this.onChangeCardNumber}> </MaskedTextBoxComponent >*/}
                                    <Input type="text" name="cardnumber" id="cardnumber"
                                        placeholder="Card Number" value={this.state.cardNumberShow} onChange={this.onChangeCardNumber} onBlur={this.onCardNumberBlur} onFocus={this.onCardNumberFocus} />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="verficationnumber">Verfication Number</Label>
                                    <Input type="text" name="verficationnumber" id="verficationnumber"
                                        placeholder="Verfication Number" onChange={this.onChangeCardVerficationNumber} />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="expirationdate">Expiration Date</Label>
                                    <InputGroup>
                                        <Example />
                                    </InputGroup>

                                </FormGroup>
                                <Button color="secondary" style={{ float: "right" }} onClick={this.props.onCloseCreditCardPopup}>Cancel</Button>
                                <Button style={{ float: "right", marginRight: "1%" }} color="primary" onClick={() => { cardUtils.validate_card_info(this) }}>Submit</Button>
                                
                            </Fragment>
                        </Col>
                        <Col sm="6">
                            <Form>
                                <FormGroup>
                                    <Label style={{ fontWeight: "bold" }}>Billing Information</Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="addressline">Address line *</Label>
                                    <Input type="text" name="addressline" id="addressline"
                                        placeholder="Address line" onChange={this.onChangeCardAddress} />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="City">City</Label>
                                    <Input type="text" name="City" id="City"
                                        placeholder="City" onChange={this.onChangeCardCity} />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="State">State</Label>
                                    <CustomInput id="ddlcardType" type="select" size="1" onChange={this.onChangeCardState}>
                                        <option value="">Select State*</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="DC">District Of Columbia</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NV">Nevada</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </CustomInput>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="ZIPCode">ZIP Code *</Label>
                                    <Input type="text" name="ZIPCode" id="ZIPCode"
                                        placeholder="ZIP Code" onChange={this.onChangeCardZIPCode} />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Country">Country </Label>
                                    <br />
                                    <Label style={{ marginTop:"4%" }}> United States (USA)</Label>
                                </FormGroup>
                                {this.props.showEmail === true ? <FormGroup>
                                    <Label for="Email">Email *</Label>
                                    <br />
                                    <Input type="email" onChange={this.onChangeEmail} />
                                </FormGroup> : null}
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Fragment>
    }
}